import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowMove24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowMove24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.64 6.53a.75.75 0 0 1 0-1.06l2.828-2.828.53-.53.53.53 2.829 2.828a.75.75 0 0 1-1.06 1.06L12.77 5.006v6.331h6.332L17.47 9.702a.75.75 0 1 1 1.06-1.06l2.829 2.828.53.53-.53.53-2.829 2.83a.75.75 0 0 1-1.06-1.061l1.462-1.463H12.77v6.182l1.548-1.548a.75.75 0 1 1 1.06 1.06l-2.828 2.83-.53.53-.53-.53-2.829-2.83a.75.75 0 0 1 1.06-1.06l1.549 1.548v-6.182H5.068L6.53 14.3a.75.75 0 1 1-1.06 1.06l-2.83-2.829-.53-.53.53-.531 2.83-2.828a.75.75 0 0 1 1.06 1.06l-1.634 1.634h6.375V4.96L9.7 6.53a.75.75 0 0 1-1.061 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowMove24);
